// Bootstrapのスタイルシート側の機能を読み込む
//import 'bootstrap/dist/css/bootstrap.min.css';

import './sass/style.scss'; //バンドルするCSSの読み込み

//JSファイルの読み込み

import './js/smooth';
// import './js/scroll';
// import './js/main';
// import './js/slide';
// import './js/swiper-custom';
import './js/mainScript';
import './js/mouse';

// import { preloadImages, preloadFonts } from './js/utils';
// import LocomotiveScroll from 'locomotive-scroll';

// if (window.matchMedia('(min-width: 1180px)').matches) {
//   console.log('1180px over');
//   // Initialize Locomotive Scroll (horizontal direction)
//   const lscroll = new LocomotiveScroll({
//     el: document.querySelector('[data-scroll-container]'),
//     smooth: true,
//     multiplier: 1,
//     direction: 'horizontal',
//     //horizontalGesture: true,
//   });

//   // Preload images and fonts
//   // Promise.all([
//   //   preloadImages('.gallery__item-imginner'),
//   //   // preloadFonts('vxy2fer'),
//   // ]).then(() => {
//   //   // Remove loader (loading class)
//   //   document.body.classList.remove('loading');

//   // Initialize custom cursor
//   //   const cursor = new Cursor(document.querySelector('.cursor'));

//   // Mouse effects on all links and others
//   //   [...document.querySelectorAll('a')].forEach((link) => {
//   //     link.addEventListener('mouseenter', () => cursor.enter());
//   //     link.addEventListener('mouseleave', () => cursor.leave());
//   //   });
//   // });
// }    //
//lazyload plugin
(function () {
  new Progressive({
    el: '#page',
    lazyClass: 'lazy',
    removePreview: true,
    scale: true,
  }).fire();
})();
// BootstrapのJavaScript側の機能を読み込む
//import 'bootstrap';
//require('progressive-image');
// require('intersection-observer'); //使うプラグイン指定
// // import 'whatwg-fetch';
// window.jQuery = window.$ = require('jquery');
// const scrollContainer = document.querySelector('main');

// scrollContainer.addEventListener('wheel', (evt) => {
//   evt.preventDefault();
//   scrollContainer.scrollLeft += evt.deltaY;
// });
